// @flow
import logStats from 'app/common/lib/logStats';
import { track } from 'app/common/lib/react/analytics';

type Source = {
  utmSource: ?string,
  utmPartner: ?string,
};
// business logic events

type BusinessEventDetails = {
  source: Source,
  isAuth: boolean,
  unifiedSignup: boolean,
};

type CreateAttemptEvent = 'client.partner.account.create_attempt';
type CreateEvent = 'client.partner.account.create';
type ConvertAttemptEvent = 'client.partner.account.convert_attempt';
type ConvertEvent = 'client.partner.account.convert';

type BusinessEvent = CreateAttemptEvent | CreateEvent | ConvertAttemptEvent | ConvertEvent;

type QuickPromoteEvent = 'click' | 'render';
export type QuickPromoteButtonLocation =
  | 'ads_credits_profile'
  | 'biz_hub_create_ad'
  | 'board_promote_first_pin'
  | 'closeup_audience_estimation'
  | 'navbar_create_ad'
  | 'pin_create_success'
  | 'pin_create_success_pinner'
  | 'pin_create_success_audience_estimation'
  | 'pin_rep'
  | 'pinanalytics'
  | 'promotable_pins_section'
  | 'promote_another_pin_upsell'
  | 'snapshot_profile_card';

type QuickPromoteAuxData = {
  audience_sizing_reach_estimation?: string,
  audience_sizing_coterie_score?: string,
  audience_sizing_coterie_id?: string,
  grid_index?: number,
  page?: string,
  pin_id?: string,
  view?: $Values<any>,
  viewParameter?: $Values<any>,
};

const isEventFromPartnerPaid = (eventDetails: BusinessEventDetails) =>
  eventDetails.source &&
  eventDetails.source.utmPartner &&
  eventDetails.source.utmPartner === 'partneracquisition';

export const logBusinessEvent = (event: BusinessEvent, details?: BusinessEventDetails) => {
  const isAuth = Boolean(details && details.isAuth);
  const unifiedSignup = Boolean(details && details.unifiedSignup);
  // event is from smb-paid team
  if (details && isEventFromPartnerPaid(details)) {
    logStats.increment(event, 1, {
      app_type: 'web',
      is_paid: true,
      paid_source: details.source.utmSource,
      is_auth: isAuth,
      unified_signup: unifiedSignup,
    });
  } else {
    logStats.increment(event, 1, {
      app_type: 'web',
      is_auth: isAuth,
      unified_signup: unifiedSignup,
    });
  }
};

export const logQuickPromoteUpsellEvent = (
  event: QuickPromoteEvent,
  location: QuickPromoteButtonLocation,
) => {
  const fullEvent = `client.partner.quick_promote_button.${event}`;
  logStats.increment(fullEvent, 1, { app_type: 'web', location });
};

export const contextLogQuickPromoteEvent = (
  eventType: PCONST.thrift.EventType.RENDER | PCONST.thrift.EventType.CLICK,
  componentType: $Values<PCONST.thrift.ComponentType>,
  viewType: $Values<PCONST.thrift.ViewType> | null,
  auxData: QuickPromoteAuxData = {},
) => {
  const data = {
    component: componentType,
    element: PCONST.thrift.ElementType.QUICK_PROMOTE_BUTTON,
    view: viewType,
    ...auxData,
  };
  track(eventType, data);
};

export const logQuickPromoteEvents = (
  event: QuickPromoteEvent,
  location: QuickPromoteButtonLocation,
  eventType: PCONST.thrift.EventType.RENDER | PCONST.thrift.EventType.CLICK,
  componentType: $Values<PCONST.thrift.ComponentType>,
  viewType: $Values<PCONST.thrift.ViewType> | null,
  auxData: QuickPromoteAuxData = {},
) => {
  //logQuickPromoteUpsellEvent call to real-time logging
  logQuickPromoteUpsellEvent(event, location);
  contextLogQuickPromoteEvent(eventType, componentType, viewType, auxData);
};

export default null;
